import React from 'react'
import { useNavigate } from 'react-router'
import { simpleCallRpc } from '../utils/api-client'
import { useTelegram } from '../utils/useTelegram';
// import { simpleCallRpcMainDB } from '../utils/api-client-main-db'
// import setLanguage from '../utils/language/index'
// import readCookie from '../utils/readCookie'
// import useLocalStorageState from 'use-local-storage-state'
// import { v4 as uuidv4 } from 'uuid'
const UserContext = React.createContext();
function UserProvider(props) {
    const navigate = useNavigate()
    const { tguser, colorScheme } = useTelegram();
    const [isAuth, setIsAuth] = React.useState(false)
    const [workspaces, setWorkspaces] = React.useState([])
    const [selected_workspace, setSelectedWorkspace] = React.useState({});

    React.useEffect(()=>{
        simpleCallRpc({ tguser, colorScheme }, true, 'app_wbaam_get_user_workspaces', {do_not_delete_user_id_from_arg:true})
        .then((data) => {
            //console.log('data=',data)
            if(data?.is_ok) {
                setIsAuth(true)
                setWorkspaces(data?.data)
            }
            else {
                setIsAuth(false)
                setWorkspaces([])
            }
        })
    },[])

  return (
    <UserContext.Provider
      value={{
        isAuth, tguser, colorScheme,
        workspaces, selected_workspace, setSelectedWorkspace
        // setWorkspaces,
        // setSelectedWorkspace,
      }}
      {...props}
    />
  );
}

export { UserProvider, UserContext };